import { getAccountScopeUserSettings } from "owa-session-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import getModuleContextMailboxInfo from "owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo";
import type WebSessionType from "owa-service/lib/contract/WebSessionType";

export function showSignInStateChangedInfoBar(): boolean {
    return isGlobalFeatureEnabled("auth-signInStateChanged-v2") && isExoConsumer();
}

function isExoConsumer(): boolean {
    const sessionType = getAccountScopeUserSettings(getModuleContextMailboxInfo()).SessionSettings
        ?.WebSessionType;
    return sessionType === 1;
}
